/** @module csi/widget/_svg/Autospace */
define([
	"dijit/form/ToggleButton",
	"csi/locale",
	"underscore",
	"./_Plugin",
	"./PluginFactory",
	"./util",
], function(ToggleButton, locale, _, _Plugin, PluginFactory, svgUtil) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		"class": "csi-button-switch",
		pluginName: "ToggleLabels",
		title: locale.resource("CanvasGroupLabelToggleLabels"),

		/**
		 * Enable and disable the icon
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const { showLabel } = svgUtil.placeholderFilledAndShowLabel(shapes);
			this.set("checked", showLabel);
			return true;
		},

		/** on click handler */
		onClick: function() {
			const { editor } = this;
			const { canvasApp } = editor;
			canvasApp.pageApi().togglePlaceholderLabels();
			editor.updateToolbar(); // update toolbar for _PlaceholderTextFormat.js plugin
		}
	});
});
